/** True for real iOS devices (iPhone/iPad/iPod). Mac desktop is intentionally excluded — it gets Gmail web. */
export function isIOS(userAgent: string = navigator.userAgent): boolean {
  return /iPhone|iPad|iPod/i.test(userAgent);
}

/**
 * Build a "compose to this contact" Gmail URL for the current device.
 * - iOS  → the Gmail app scheme (`googlegmail:///co`). The app uses its own active account.
 * - else → Gmail web compose, targeted at the rep's connected work account via `/mail/u/<email>/`
 *          (falls back to `/u/0/` when the address is unknown).
 * Only the recipient is prefilled (parity with the mailto handoff).
 */
export function buildGmailComposeUrl(
  email: string,
  opts: { googleEmail?: string | null; userAgent?: string } = {},
): string {
  const ua = opts.userAgent ?? navigator.userAgent;
  const to = encodeURIComponent(email);
  if (isIOS(ua)) {
    return `googlegmail:///co?to=${to}`;
  }
  const account = opts.googleEmail || '0';
  return `https://mail.google.com/mail/u/${account}/?view=cm&fs=1&to=${to}`;
}
